<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.leadSummary.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      <form [formGroup]="bucketGroupForm" class="bucket-group-form no-print">
        <formly-form [form]="bucketGroupForm" [fields]="bucketGroupFields" [model]="bucketGroupModel" />
      </form>

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (rows().length === 0) {
        <p class="empty-state" data-testid="lead-summary-empty">{{ 'reports.leadSummary.empty' | translate }}</p>
      } @else {
        <table class="report-table" data-testid="lead-summary-table">
          <thead>
            <tr>
              <th>{{ 'reports.rateTrends.date' | translate }}</th>
              <th>{{ 'reports.rateTrends.group' | translate }}</th>
              <th>{{ 'reports.leadSummary.leads' | translate }}</th>
              <th>{{ 'reports.leadSummary.totalValue' | translate }}</th>
              <th>{{ 'reports.leadSummary.won' | translate }}</th>
              <th>{{ 'reports.leadSummary.lost' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.bucketLabel + row.groupKey) {
              <tr>
                <td>{{ row.bucketLabel }}</td>
                <td>{{ row.groupLabel }}</td>
                <td>{{ row.leadCount }}</td>
                <td>{{ row.totalValue.toFixed(2) }}</td>
                <td>{{ row.wonCount }}</td>
                <td>{{ row.lostCount }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </app-card-content>
    @if (canExport) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
